import React from 'react';
import style from '../../css/ContactTop.module.css';
import { FaClock, FaEnvelope, FaPhoneAlt, FaUser } from 'react-icons/fa';

function ContactTop() {
	const data = [
		{
			id: 0,
			title: 'Address',
			txt: 'Nelamangala, Bangalore, India',
			icon: <FaUser />,
		},
		{
			id: 1,
			title: 'Phone',
			txt: '8884264377',
			icon: <FaPhoneAlt />,
		},
		{
			id: 2,
			title: 'E-mail ID',
			txt: 'kanasucyber128@gmail.com',
			icon: <FaEnvelope />,
		},
		{
			id: 3,
			title: 'Opening Hours',
			txt: 'Mon-Sat : 8AM-8PM <br />Sunday : 8AM-1PM',
			icon: <FaClock />,
		},
	];

	return (
		<div className={style.container}>
			<img
				src={require('../images/contact_image.jpg')}
				alt="Image"
				className={style.image}
			/>

			<div className={style.txtCon}>
				<p className={style.txt}>How can we help you?</p>
				<p className={style.txt1}>
					We always want to hear from you! Let us know if there is <br />
					anything that we can help you with.
				</p>
			</div>

			<div className={style.info}>
				<div className={style.info1}>
					{data.map((item) => {
						return (
							<div className={style.coloum} key={item.id}>
								<div className={style.icon}>{item.icon}</div>
								<p className={style.title}>{item.title}</p>
								<p
									className={style.txt2}
									dangerouslySetInnerHTML={{ __html: item.txt }}
								/>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}

export default ContactTop;
